import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const roleApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/shop/role",
      params,
    }),
  findOne: (roleId: number): AxiosPromise<any> =>
    request({
      url: `/v1/shop/role/${roleId}`,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/shop/role",
      data,
      method: "post",
    }),
  getPermission: (): AxiosPromise<any> =>
    request({
      url: `/v1/shop/role/permissions`,
    }),
  importPermission: (data: any): AxiosPromise<any> =>
    request({
      url: `/v1/shop/role/permissions/import`,
      method: "post",
      data,
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/shop/role/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/shop/role/${id}`,
      method: "delete",
    }),
};
